import { PromoComponent } from '@/mainComponent/PromoComponent';
import { ACTION } from '@/store/ACTION';

class PopupAchievementCounterController {
  protected allowed(): boolean {
    const isStartedGames: boolean =
      this.store.gameData.freeSpinsGame.isPlaying() ||
      this.store.gameData.freeSpinsGame.isStarted() ||
      this.store.gameData.bonusGame.isPlaying() ||
      this.store.gameData.bonusGame.isStarted();
    return (
      this.store.promo.hasPromoApp() &&
      this.store.promo.isAchievement &&
      Boolean(this.store.promo.achievementCounterTotal) &&
      this.store.promo.achievementCounterLeft === 0 &&
      this.store.promo.isProgressGame() &&
      !isStartedGames
    );
  }

  execution(): void {
    if (!this.allowed()) return;
    promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_FINISH);
    this.store.promo.resetAchievement();
    game.emit(PromoComponent.events.END_ACHIEVEMENT);
  }

  get store() {
    return game.store;
  }
}

export { PopupAchievementCounterController };
